import React from "react"
import { useState } from "react"
import { Barcode, ChevronDown } from "lucide-react"
import Create from './Create'
import FreshCodes from "./Fresh"
import Fresh from "./Fresh"
import Sent from "./Sent"
import Assigned from "./Assigned"

type tabs = "create" | "fresh" | "sent" | "assigned"

export default function GiftCodeCreation() {

    const [currentTab, setCurrentTab] = useState("create" as tabs)


    return (
        <>
            <div className="flex flex-col w-full ">
                <div className="w-1/3 text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
                    <Barcode />
                    Gift Code Creation
                </div>
                <div className="flex w-2/3 justify-initial pb-3 gap-2">
                    <button
                        onClick={() => setCurrentTab("create")}
                        className={`hover:bg-blue-100 hover:text-blue-600 font-medium py-2 px-4 rounded-xl transition-colors 
                        ${currentTab === "create" ? "text-white bg-blue-600" : "text-blue-600"}`} >
                        Create Codes
                    </button>
                    <button
                        onClick={() => setCurrentTab("fresh")}
                        className={`hover:bg-blue-100 hover:text-blue-600 font-medium py-2 px-4 rounded-xl transition-colors
                        ${currentTab === "fresh" ? "text-white bg-blue-600" : "text-blue-600"}`} >
                        Fresh Codes
                    </button>
                    <button
                        onClick={() => setCurrentTab("sent")}
                        className={`hover:bg-blue-100 hover:text-blue-600 font-medium py-2 px-4 rounded-xl transition-colors
                        ${currentTab === "sent" ? "text-white bg-blue-600" : "text-blue-600"}`} >
                        Sent Codes
                    </button>
                    <button
                        onClick={() => setCurrentTab("assigned")}
                        className={`hover:bg-blue-100 hover:text-blue-600 font-medium py-2 px-4 rounded-xl transition-colors
                        ${currentTab === "assigned" ? "text-white bg-blue-600" : "text-blue-600"}`} >
                        Assigned Codes
                    </button>
                </div>
            </div>

            {currentTab === "create" && <Create />}
            {currentTab === "fresh" && <Fresh />}
            {currentTab === "sent" && <Sent />}
            {currentTab === "assigned" && <Assigned />}
        </>

    )
}